/* eslint-disable */
// Centralized i18n strings. EN is the default; IT is a translation. Add new
// keys here and reference them with the `useT()` hook from LanguageContext.
import { FR, FR_RISK_LABELS } from "./fr";
import { ES, ES_RISK_LABELS } from "./es";

export const STRINGS = {
  en: {
    // ---- shared layout ----
    "layout.subtitle": "Clinical Simulator · v1.0.0",
    "layout.poweredBy": "Powered by",
    "layout.signIn": "Sign in",
    "layout.logout": "Logout",
    "nav.overview": "Overview",
    "nav.simulator": "Simulator",
    "nav.configuration": "Configuration",
    "footer.source": "Source: Simulatore SEPSI_EMO (20250822) · LDA + Decision Trees",
    "footer.tech": "Deployable on Azure · JSON config · MongoDB persistence",

    // ---- overview ----
    "ov.kicker": "Clinical Decision Support · 01",
    "ov.titleA": "Sepsi Index Framework",
    "ov.titleB": "calculation platform.",
    "ov.description":
      "A framework designed to classify Sepsis cases from other diseases or infections based on complete blood count analytes.",
    "ov.openSimulator": "Open Patient Simulator →",
    "ov.editConfig": "Edit Configuration",
    "ov.activeConfig": "Active Configuration",
    "ov.card.variables": "Variables",
    "ov.card.variables.sub": "hematological inputs",
    "ov.card.classes": "LDA Classes",
    "ov.card.classes.sub": "No SEPSIS + 4 alert days",
    "ov.card.rules": "Decision Rules",
    "ov.card.rules.sub": "leaf-level tree rules",
    "ov.card.version": "Config Version",
    "ov.sponsor.label": "A project sponsored by",
    "ov.sponsor.tagline": "AI-Care for a better life",
    "ov.step": "Step",
    "ov.step1.title": "Clinical data entry",
    "ov.step1.body":
      "The clinician accesses the application via mobile (APP) or desktop (webapp) and enters the patient's complete blood count, already available in the early stage of the assessment in the Emergency Department.",
    "ov.step2.title": "Predictive indicator computation",
    "ov.step2.body":
      "The system automatically processes the data through three independent predictive models. The clinician can review and select the model deemed most consistent with the patient's clinical profile, retaining full control of the decision.",
    "ov.step3.title": "Clinical output and decision support",
    "ov.step3.bodyIntro": "The application returns:",
    "ov.step3.bullet1": "a sepsis probability percentage,",
    "ov.step3.bullet2":
      "risk alerts for the first 4 days following the analysis, providing early support for risk stratification — without replacing clinical judgment.",

    // ---- simulator ----
    "sim.kicker": "Section 02",
    "sim.title": "Patient Simulator",
    "sim.description":
      "Enter the 20 hematological values, pick a preset, or edit field by field. The API returns the Linear Discriminant, Decision Tree and combined risk on every calculation.",
    "sim.sponsoredBy": "Sponsored by",
    "sim.reset": "Reset",
    "sim.calculate": "Calculate Sepsis Risk →",
    "sim.calculating": "Calculating…",
    "sim.awaiting.title": "Awaiting calculation",
    "sim.awaiting.body":
      "Fill the form (or load a preset) and click Calculate to see the discriminant analysis, decision-tree path and combined risk class.",
    "sim.group.neutrophils": "Neutrophils",
    "sim.group.lymphocytes": "Lymphocytes",
    "sim.group.monocytes": "Monocytes",
    "sim.group.rdw": "Red-blood-cell variability",
    "sim.group.ratios": "Ratios",
    "sim.group.platelets": "Platelets",
    "sim.result.combined": "Combined Sepsis Probability",
    "sim.result.compare": "Methodology comparison",
    "sim.result.perClass": "Per-class probability (combined)",
    "sim.result.path": "Decision-tree path · node",
    "sim.method.lda": "Linear Discriminant",
    "sim.method.tree": "Decision Trees",
    "sim.method.combined": "Combined (MAX)",
    "sim.result.txId": "Transaction ID",
    "sim.result.txIdHint": "Save this ID on the patient chart to validate the prediction later.",
    "sim.result.copy": "Copy",
    "sim.result.copied": "Copied",
    "sim.patientRef.label": "Patient reference (optional)",
    "sim.patientRef.placeholder": "e.g. chart # or internal ID",
    "sim.patientRef.help": "Optional. Stored with the transaction so you can search this prediction later from the History page.",
    "sim.result.patientRef": "Patient reference",

    // ---- config ----
    "cfg.kicker": "Section 03",
    "cfg.title": "Configuration",
    "cfg.description":
      "Edit weights, decision-tree leaves, risk bands and authorized users. Changes are persisted in MongoDB.",
    "cfg.import": "Import Excel…",
    "cfg.export": "Export JSON",
    "cfg.reset": "Reset defaults",
    "cfg.save": "Save",
    "cfg.saving": "Saving…",
    "cfg.saved": "Configuration saved",
    "cfg.resetDone": "Reset to default config",
    "cfg.extracted": "Extracted from Excel — click Save to activate",
    "cfg.tab.lda": "Discriminant weights",
    "cfg.tab.tree": "Decision tree",
    "cfg.tab.thresholds": "Risk thresholds",
    "cfg.tab.users": "Users",
    "cfg.tab.apitokens": "API Tokens",
    "tok.title": "API Tokens",
    "tok.subtitle": "Long-lived bearer tokens for server-to-server clients (e.g. an Azure Function). Tokens are bound to a robot email that must already be on the allow-list — removing it instantly disables every token issued for that identity.",
    "tok.create.heading": "Mint a new API token",
    "tok.create.name": "Name",
    "tok.create.name.placeholder": "e.g. Azure Function — Production",
    "tok.create.email": "Robot email",
    "tok.create.email.help": "Pick an identity already on the allow-list. The robot email will appear in every audit log row produced by this token.",
    "tok.create.email.empty": "No emails on the allow-list yet. Add one in the Users tab first.",
    "tok.create.ttl": "Lifetime",
    "tok.create.ttl.30": "30 days",
    "tok.create.ttl.90": "90 days",
    "tok.create.ttl.365": "1 year",
    "tok.create.ttl.none": "No expiry (revoke-only)",
    "tok.create.submit": "Generate token",
    "tok.create.submitting": "Generating…",
    "tok.minted.title": "Token created — copy it now",
    "tok.minted.warning": "This is the only time the full token will be displayed. Save it in a secret manager (Azure Key Vault, AWS Secrets Manager, etc.) before closing this banner.",
    "tok.minted.copy": "Copy token",
    "tok.minted.copied": "Copied",
    "tok.minted.dismiss": "I have saved it — dismiss",
    "tok.list.heading": "Existing tokens",
    "tok.list.empty": "No API tokens issued yet.",
    "tok.col.name": "Name",
    "tok.col.robot": "Robot email",
    "tok.col.created": "Created",
    "tok.col.expires": "Expires",
    "tok.col.lastUsed": "Last used",
    "tok.col.status": "Status",
    "tok.status.active": "Active",
    "tok.status.revoked": "Revoked",
    "tok.status.expired": "Expired",
    "tok.noExpiry": "No expiry",
    "tok.never": "Never",
    "tok.revoke": "Revoke",
    "tok.revoke.confirm": "Revoke this token? Clients using it will start receiving 401 immediately.",
    "cfg.lda.variable": "Variable",
    "cfg.lda.intercept": "Intercept",
    "cfg.tree.node": "Node",
    "cfg.tree.count": "Count",
    "cfg.thr.threshold": "Threshold (≥)",
    "cfg.thr.labelEn": "Label (EN)",
    "cfg.thr.labelIt": "Label (IT)",
    "cfg.users.title": "Authorized users",
    "cfg.users.active": "active",
    "cfg.users.you": "You · cannot remove",
    "cfg.users.remove": "Remove",
    "cfg.users.invite": "Invite new user",
    "cfg.users.help":
      "Add a Google email. The user will be able to sign in via Google and access the protected pages once their email is on this list. Removing an email revokes future logins (existing tokens expire within 12h).",
    "cfg.users.add": "Add to allowlist",
    "cfg.users.signedIn": "Currently signed in as",
    "cfg.users.loading": "Loading users…",
    "cfg.errors.invalidEmail": "Invalid email format",
    "cfg.errors.dup": "Email already in the allowlist",
    "cfg.errors.removeSelf": "You cannot remove your own email",
    "cfg.users.updated": "Authorized users updated",
    "cfg.loading": "Loading configuration…",

    // ---- login ----
    "login.kicker": "Restricted area",
    "login.titleA": "Sign in to access",
    "login.titleB": "the platform.",
    "login.description":
      "The Simulator and the Configuration are restricted to an email allowlist. Only the public Overview is reachable without authentication.",
    "login.step1": "Click Sign in with Google",
    "login.step2": "Authorize in the Google popup",
    "login.step3": "Your email is matched against the server allowlist",
    "login.step4": "On success you are redirected to your destination",
    "login.provider": "Google OAuth 2.0",
    "login.cta": "Sign in with Google",
    "login.signingIn": "Signing in…",
    "login.note":
      "We only read your email address. Your email must be in the allowlist to obtain a session token.",

    // ---- protected route ----
    "auth.checking": "Checking authentication…",

    // ---- transactions ----
    "nav.transactions": "History",
    "tx.kicker": "Clinical Audit · 05",
    "tx.title": "Transaction history",
    "tx.description":
      "Every prediction is recorded with input, output and caller. As an administrator you can validate each case as Correct or Incorrect to support retrospective accuracy analysis and future model tuning.",
    "tx.filter.all": "All",
    "tx.filter.pending": "Pending",
    "tx.filter.yes": "Correct (YES)",
    "tx.filter.no": "Incorrect (NO)",
    "tx.filter.caller": "Filter by caller email…",
    "tx.filter.id": "Search by Transaction ID…",
    "tx.filter.ref": "Search by patient reference…",
    "tx.filter.clear": "Clear",
    "tx.export.csv": "Export CSV",
    "tx.export.csv.exporting": "Exporting…",
    "tx.export.csv.help": "Downloads all transactions matching the current filters as a CSV file (Excel-friendly, UTF-8 with BOM). Includes one column per patient variable.",
    "tx.empty": "No transactions yet. Run a calculation in the Simulator (or call POST /api/calculate) to log the first one.",
    "tx.empty.search": "No transaction matches your search.",
    "tx.col.id": "Transaction ID",
    "tx.col.ref": "Patient ref.",
    "tx.col.when": "When",
    "tx.col.caller": "Caller",
    "tx.col.prob": "P(SEPSIS)",
    "tx.col.class": "Risk class",
    "tx.col.validation": "Validation",
    "tx.col.actions": "",
    "tx.detail.expand": "Show details",
    "tx.detail.collapse": "Hide details",
    "tx.delete": "Delete",
    "tx.delete.confirm": "Delete this transaction permanently? This cannot be undone — the prediction will be removed from the audit log and accuracy stats.",
    "tx.detail.input": "Input",
    "tx.detail.output": "Output (combined)",
    "tx.detail.path": "Decision-tree path",
    "tx.validation.pending": "Pending",
    "tx.validation.yes": "Correct",
    "tx.validation.no": "Incorrect",
    "tx.validation.markYes": "Mark Correct",
    "tx.validation.markNo": "Mark Incorrect",
    "tx.validation.clear": "Clear",
    "tx.validation.notes": "Notes (optional)",
    "tx.validation.notesPh": "Clinical observations, chart review reference, follow-up…",
    "tx.validation.save": "Save validation",
    "tx.validation.by": "Validated by",
    "tx.validation.at": "on",
    "tx.stats.total": "Total",
    "tx.stats.pending": "Pending",
    "tx.stats.yes": "Correct",
    "tx.stats.no": "Incorrect",
    "tx.loading": "Loading transactions…",
    "tx.refresh": "Refresh",

    // ---- accuracy dashboard ----
    "nav.accuracy": "Accuracy",
    "acc.kicker": "Model Performance · 06",
    "acc.title": "Retrospective accuracy",
    "acc.description":
      "Live accuracy of the predictive model based on the YES/NO validations recorded in the History. Use it to monitor performance drift, identify weak risk-class buckets and guide model retuning.",
    "acc.refresh": "Refresh",
    "acc.headline.label": "Validated accuracy",
    "acc.headline.empty": "No validated cases yet — go to History and mark some transactions to populate the dashboard.",
    "acc.headline.basis": "based on",
    "acc.headline.basis2": "validated cases",
    "acc.summary.total": "Total transactions",
    "acc.summary.validated": "Validated",
    "acc.summary.pending": "Pending review",
    "acc.summary.coverage": "Coverage",
    "acc.byClass.title": "Accuracy by risk class",
    "acc.byClass.empty": "Validate at least one case to break down accuracy by risk class.",
    "acc.byClass.class": "Risk class",
    "acc.byClass.cases": "Cases",
    "acc.byClass.correct": "Correct",
    "acc.byClass.incorrect": "Incorrect",
    "acc.byClass.accuracy": "Accuracy",
    "acc.byDay.title": "Last N days",
    "acc.byDay.subtitle": "Daily accuracy (only days with validations are plotted)",
    "acc.byDay.empty": "No validated cases in this window.",
    "acc.byCaller.title": "Top callers",
    "acc.byCaller.empty": "No callers with validated cases yet.",
    "acc.byCaller.email": "Caller",
    "acc.byCaller.cases": "Cases",
    "acc.byCaller.accuracy": "Accuracy",
    "acc.window.7": "7 days",
    "acc.window.30": "30 days",
    "acc.window.90": "90 days",
    "acc.window.all": "All time",
    "acc.loading": "Computing metrics…",

    "nav.api": "API",
    "lang.label": "Language",
    "cfg.thr.labelFr": "Label (FR)",
    "cfg.thr.labelEs": "Label (ES)",
    "login.errors.failed": "Login failed",
    "login.errors.cancelled": "Google sign-in was cancelled",
    "tx.copyId": "Copy transaction ID",
    "docs.kicker": "Developer Reference · 04",
    "docs.title": "API for HTTP clients",
    "docs.intro":
      "The Sepsi Index Framework exposes a REST API. Any HTTP client (curl, Postman, Python, a backend service…) can compute sepsis risk after authenticating with a **Google identity** that is on the authorized-users allowlist.",
    "docs.interactive.title": "Interactive documentation",
    "docs.interactive.body":
      "The full OpenAPI 3.1 schema is generated automatically. Use Swagger UI to try each endpoint live (paste a Google ID token in **Authorize**), or import the raw JSON into Postman, Insomnia or an OpenAPI codegen.",
    "docs.interactive.swagger": "Open Swagger UI",
    "docs.baseUrl": "Base URL",
    "docs.auth.title": "Authentication",
    "docs.auth.intro":
      "Pass a Bearer token in the `Authorization` header. The server accepts **two equivalent** token formats:",
    "docs.auth.google.title": "Google ID token (recommended for HTTP clients)",
    "docs.auth.google.body":
      "— any ID token issued by Google's OAuth for our client ID ({clientId}). It must be signed with RS256, have a verified email, and the email must be on the allowlist.",
    "docs.auth.app.title": "App JWT",
    "docs.auth.app.body":
      "— the short-lived HS256 token returned by `POST /api/auth/google` (used by the SPA after the Google popup flow).",
    "docs.auth.errors":
      "On `401` the response carries `WWW-Authenticate: Bearer`. A `403` means the token is valid but the email is **not on the allowlist** — ask an admin to add it from the **Configuration → Users** page.",
    "docs.endpoints.title": "Endpoints",
    "docs.col.method": "Method",
    "docs.col.path": "Path",
    "docs.col.auth": "Auth",
    "docs.col.desc": "Description",
    "docs.bearerRequired": "Bearer required",
    "docs.public": "public",
    "docs.ep.calculate": "Compute sepsis risk for one patient.",
    "docs.ep.health": "Liveness probe (counts of vars/rules/version).",
    "docs.ep.config": "Returns the active configuration (read-only).",
    "docs.ep.examples": "Three preset patient cases (low / medium / high risk).",
    "docs.ep.configPut": "Replace the active configuration (admin).",
    "docs.ep.configReset": "Restore default model (preserves allowlist).",
    "docs.ep.configExtract": "Extract a config from a reference Excel (multipart upload).",
    "docs.ep.emailsGet": "List authorized users.",
    "docs.ep.emailsPut": "Replace the allowlist.",
    "docs.payload.title": "Request payload — POST /api/calculate",
    "docs.payload.body":
      "The body contains a single `patient` object with the 20 hematological values. Missing values are treated as zero in the LDA model and skip the corresponding decision-tree conditions.",
    "docs.curl.title": "Example · curl + gcloud",
    "docs.curl.body":
      "The easiest one-liner: once you are logged in to gcloud (`gcloud auth login`) you can mint short-lived ID tokens scoped to our OAuth client.",
    "docs.python.title": "Example · Python",
    "docs.python.body":
      "Requires a **Desktop-app OAuth client** in Google Cloud Console (separate from the Web client used by the SPA). On first run the script opens a browser tab once; subsequent runs reuse the stored refresh token automatically.",
    "docs.s2s.title": "Server-to-server (service account)",
    "docs.s2s.body":
      "For backend integrations, create a Google Cloud **service account**, add its email (`name@project.iam.gserviceaccount.com`) to the allowlist, and use `google.oauth2.service_account.IDTokenCredentials` with `target_audience` set to our OAuth Client ID. The minted ID token works the same way.",
    "docs.copy": "COPY",
    "docs.copied": "COPIED",
  },

  it: {
    "layout.subtitle": "Simulatore Clinico · v1.0.0",
    "layout.poweredBy": "Powered by",
    "layout.signIn": "Accedi",
    "layout.logout": "Esci",
    "nav.overview": "Panoramica",
    "nav.simulator": "Simulatore",
    "nav.configuration": "Configurazione",
    "footer.source":
      "Fonte: Simulatore SEPSI_EMO (20250822) · LDA + Alberi Decisionali",
    "footer.tech": "Pronto per Azure · Configurazione JSON · Persistenza MongoDB",

    "ov.kicker": "Supporto alla Decisione Clinica · 01",
    "ov.titleA": "Sepsi Index Framework",
    "ov.titleB": "piattaforma di calcolo.",
    "ov.description":
      "Un framework progettato per distinguere i casi di Sepsi da altre malattie o infezioni a partire dagli analiti dell'emocromo.",
    "ov.openSimulator": "Apri il Simulatore Paziente →",
    "ov.editConfig": "Modifica Configurazione",
    "ov.activeConfig": "Configurazione Attiva",
    "ov.card.variables": "Variabili",
    "ov.card.variables.sub": "valori ematologici in input",
    "ov.card.classes": "Classi LDA",
    "ov.card.classes.sub": "No SEPSI + 4 giorni di alert",
    "ov.card.rules": "Regole Decisionali",
    "ov.card.rules.sub": "regole foglia dell'albero",
    "ov.card.version": "Versione Configurazione",
    "ov.sponsor.label": "Progetto sponsorizzato da",
    "ov.sponsor.tagline": "AI-Care for a better life",
    "ov.step": "Step",
    "ov.step1.title": "Inserimento dei dati clinici",
    "ov.step1.body":
      "Il medico accede all'applicazione via mobile (APP) o via PC (webapp) e inserisce i valori dell'emocromo del paziente, disponibili già nella fase iniziale della valutazione in Pronto Soccorso.",
    "ov.step2.title": "Calcolo dell'indicatore predittivo",
    "ov.step2.body":
      "Il sistema elabora automaticamente i dati attraverso tre modelli predittivi indipendenti. Il medico può visualizzare e selezionare il modello ritenuto più aderente al profilo clinico del paziente, mantenendo il pieno controllo della decisione.",
    "ov.step3.title": "Output clinico e supporto decisionale",
    "ov.step3.bodyIntro": "L'applicazione restituisce:",
    "ov.step3.bullet1": "una percentuale di probabilità di sepsi,",
    "ov.step3.bullet2":
      "alert di rischio relativi ai primi 4 giorni successivi all'analisi, fornendo un supporto precoce alla stratificazione del rischio, senza sostituire il giudizio clinico.",

    "sim.kicker": "Sezione 02",
    "sim.title": "Simulatore Paziente",
    "sim.description":
      "Inserisci i 20 valori ematologici, scegli un preset, o modifica campo per campo. Ad ogni calcolo l'API restituisce la Discriminante Lineare, l'Albero Decisionale e il rischio combinato.",
    "sim.sponsoredBy": "Sponsorizzato da",
    "sim.reset": "Reimposta",
    "sim.calculate": "Calcola Rischio Sepsi →",
    "sim.calculating": "Calcolo in corso…",
    "sim.awaiting.title": "In attesa del calcolo",
    "sim.awaiting.body":
      "Compila il modulo (o carica un preset) e clicca Calcola per vedere l'analisi discriminante, il percorso dell'albero e la classe di rischio combinata.",
    "sim.group.neutrophils": "Neutrofili",
    "sim.group.lymphocytes": "Linfociti",
    "sim.group.monocytes": "Monociti",
    "sim.group.rdw": "Variabilità eritrocitaria (RDW)",
    "sim.group.ratios": "Rapporti",
    "sim.group.platelets": "Piastrine",
    "sim.result.combined": "Probabilità Combinata di Sepsi",
    "sim.result.compare": "Confronto tra metodologie",
    "sim.result.perClass": "Probabilità per classe (combinata)",
    "sim.result.path": "Percorso dell'albero · nodo",
    "sim.method.lda": "Discriminante Lineare",
    "sim.method.tree": "Alberi Decisionali",
    "sim.method.combined": "Combinato (MAX)",
    "sim.result.txId": "ID Transazione",
    "sim.result.txIdHint": "Salva questo ID nella cartella del paziente per validare la predizione in seguito.",
    "sim.result.copy": "Copia",
    "sim.result.copied": "Copiato",
    "sim.patientRef.label": "Riferimento paziente (opzionale)",
    "sim.patientRef.placeholder": "es. n° cartella o ID interno",
    "sim.patientRef.help": "Opzionale. Viene salvato con la transazione: potrai ritrovare questa predizione dallo Storico cercando per riferimento.",
    "sim.result.patientRef": "Riferimento paziente",

    "cfg.kicker": "Sezione 03",
    "cfg.title": "Configurazione",
    "cfg.description":
      "Modifica pesi, foglie dell'albero, soglie di rischio e utenti autorizzati. Le modifiche sono persistite in MongoDB.",
    "cfg.import": "Importa Excel…",
    "cfg.export": "Esporta JSON",
    "cfg.reset": "Ripristina default",
    "cfg.save": "Salva",
    "cfg.saving": "Salvataggio…",
    "cfg.saved": "Configurazione salvata",
    "cfg.resetDone": "Ripristinata configurazione di default",
    "cfg.extracted": "Estratto dall'Excel — clicca Salva per attivare",
    "cfg.tab.lda": "Pesi discriminanti",
    "cfg.tab.tree": "Albero decisionale",
    "cfg.tab.thresholds": "Soglie di rischio",
    "cfg.tab.users": "Utenti",
    "cfg.tab.apitokens": "Token API",
    "tok.title": "Token API",
    "tok.subtitle": "Token bearer a lunga durata per client server-to-server (es. una Azure Function). Ogni token è legato a un'email \"robot\" che deve essere già sulla allow-list — rimuoverla disabilita istantaneamente tutti i token emessi per quell'identità.",
    "tok.create.heading": "Genera un nuovo token API",
    "tok.create.name": "Nome",
    "tok.create.name.placeholder": "es. Azure Function — Produzione",
    "tok.create.email": "Email robot",
    "tok.create.email.help": "Scegli un'identità già presente nella allow-list. L'email robot apparirà in ogni riga del log clinico generata da questo token.",
    "tok.create.email.empty": "Nessuna email sulla allow-list. Aggiungine una prima dalla tab Utenti.",
    "tok.create.ttl": "Validità",
    "tok.create.ttl.30": "30 giorni",
    "tok.create.ttl.90": "90 giorni",
    "tok.create.ttl.365": "1 anno",
    "tok.create.ttl.none": "Nessuna scadenza (solo revoca)",
    "tok.create.submit": "Genera token",
    "tok.create.submitting": "Generazione…",
    "tok.minted.title": "Token creato — copialo ora",
    "tok.minted.warning": "Questa è l'unica volta in cui il token completo verrà mostrato. Salvalo in un gestore segreti (Azure Key Vault, AWS Secrets Manager, ecc.) prima di chiudere il banner.",
    "tok.minted.copy": "Copia token",
    "tok.minted.copied": "Copiato",
    "tok.minted.dismiss": "L'ho salvato — chiudi",
    "tok.list.heading": "Token esistenti",
    "tok.list.empty": "Nessun token API ancora emesso.",
    "tok.col.name": "Nome",
    "tok.col.robot": "Email robot",
    "tok.col.created": "Creato",
    "tok.col.expires": "Scade",
    "tok.col.lastUsed": "Ultimo uso",
    "tok.col.status": "Stato",
    "tok.status.active": "Attivo",
    "tok.status.revoked": "Revocato",
    "tok.status.expired": "Scaduto",
    "tok.noExpiry": "Nessuna scadenza",
    "tok.never": "Mai",
    "tok.revoke": "Revoca",
    "tok.revoke.confirm": "Revocare questo token? I client che lo usano riceveranno 401 immediatamente.",
    "cfg.lda.variable": "Variabile",
    "cfg.lda.intercept": "Intercetta",
    "cfg.tree.node": "Nodo",
    "cfg.tree.count": "Conteggio",
    "cfg.thr.threshold": "Soglia (≥)",
    "cfg.thr.labelEn": "Etichetta (EN)",
    "cfg.thr.labelIt": "Etichetta (IT)",
    "cfg.users.title": "Utenti autorizzati",
    "cfg.users.active": "attivi",
    "cfg.users.you": "Tu · non rimovibile",
    "cfg.users.remove": "Rimuovi",
    "cfg.users.invite": "Invita un nuovo utente",
    "cfg.users.help":
      "Aggiungi un indirizzo email Google. L'utente potrà accedere via Google e raggiungere le pagine protette una volta che la sua email è in questa lista. Rimuovendo un'email si revocano i futuri login (i token esistenti scadono entro 12h).",
    "cfg.users.add": "Aggiungi alla lista",
    "cfg.users.signedIn": "Attualmente connesso come",
    "cfg.users.loading": "Caricamento utenti…",
    "cfg.errors.invalidEmail": "Formato email non valido",
    "cfg.errors.dup": "Email già presente nella lista",
    "cfg.errors.removeSelf": "Non puoi rimuovere il tuo stesso indirizzo",
    "cfg.users.updated": "Utenti autorizzati aggiornati",
    "cfg.loading": "Caricamento configurazione…",

    "login.kicker": "Area riservata",
    "login.titleA": "Accedi per usare",
    "login.titleB": "la piattaforma.",
    "login.description":
      "Il Simulatore e la Configurazione sono riservati a una lista di email autorizzate. Solo la Panoramica pubblica è raggiungibile senza autenticazione.",
    "login.step1": "Clicca su Accedi con Google",
    "login.step2": "Autorizza nel popup di Google",
    "login.step3": "La tua email viene confrontata con la lista del server",
    "login.step4": "In caso di successo verrai reindirizzato a destinazione",
    "login.provider": "Google OAuth 2.0",
    "login.cta": "Accedi con Google",
    "login.signingIn": "Accesso in corso…",
    "login.note":
      "Leggiamo solo il tuo indirizzo email. La tua email deve essere nella lista degli autorizzati per ottenere un token di sessione.",

    "auth.checking": "Verifica dell'autenticazione…",

    "nav.transactions": "Storico",
    "tx.kicker": "Audit Clinico · 05",
    "tx.title": "Storico transazioni",
    "tx.description":
      "Ogni predizione viene registrata con input, output e chiamante. Come amministratore puoi validare ciascun caso come Corretto o Errato per supportare l'analisi retrospettiva dell'accuratezza e il tuning futuro del modello.",
    "tx.filter.all": "Tutte",
    "tx.filter.pending": "In attesa",
    "tx.filter.yes": "Corrette (YES)",
    "tx.filter.no": "Errate (NO)",
    "tx.filter.caller": "Filtra per email del chiamante…",
    "tx.filter.id": "Cerca per ID transazione…",
    "tx.filter.ref": "Cerca per riferimento paziente…",
    "tx.filter.clear": "Pulisci",
    "tx.export.csv": "Esporta CSV",
    "tx.export.csv.exporting": "Esportazione…",
    "tx.export.csv.help": "Scarica tutte le transazioni corrispondenti ai filtri attivi come CSV (Excel-friendly, UTF-8 con BOM). Include una colonna per ogni variabile paziente.",
    "tx.empty": "Nessuna transazione registrata. Esegui un calcolo dal Simulatore (o chiama POST /api/calculate) per registrare la prima.",
    "tx.empty.search": "Nessuna transazione corrisponde alla tua ricerca.",
    "tx.col.id": "ID Transazione",
    "tx.col.ref": "Rif. paziente",
    "tx.col.when": "Quando",
    "tx.col.caller": "Chiamante",
    "tx.col.prob": "P(SEPSI)",
    "tx.col.class": "Classe di rischio",
    "tx.col.validation": "Validazione",
    "tx.col.actions": "",
    "tx.detail.expand": "Mostra dettagli",
    "tx.detail.collapse": "Nascondi dettagli",
    "tx.delete": "Elimina",
    "tx.delete.confirm": "Eliminare definitivamente questa transazione? L'operazione non è reversibile — la predizione verrà rimossa dal log clinico e dalle statistiche di accuratezza.",
    "tx.detail.input": "Input",
    "tx.detail.output": "Output (combinato)",
    "tx.detail.path": "Percorso dell'albero",
    "tx.validation.pending": "In attesa",
    "tx.validation.yes": "Corretto",
    "tx.validation.no": "Errato",
    "tx.validation.markYes": "Segna come Corretto",
    "tx.validation.markNo": "Segna come Errato",
    "tx.validation.clear": "Reimposta",
    "tx.validation.notes": "Note (opzionali)",
    "tx.validation.notesPh": "Osservazioni cliniche, riferimento cartella, follow-up…",
    "tx.validation.save": "Salva validazione",
    "tx.validation.by": "Validato da",
    "tx.validation.at": "il",
    "tx.stats.total": "Totale",
    "tx.stats.pending": "In attesa",
    "tx.stats.yes": "Corrette",
    "tx.stats.no": "Errate",
    "tx.loading": "Caricamento transazioni…",
    "tx.refresh": "Aggiorna",

    "nav.accuracy": "Accuratezza",
    "acc.kicker": "Performance del Modello · 06",
    "acc.title": "Accuratezza retrospettiva",
    "acc.description":
      "Accuratezza in tempo reale del modello predittivo basata sulle validazioni YES/NO registrate nello Storico. Usala per monitorare il drift, identificare le fasce di rischio più deboli e guidare il retuning del modello.",
    "acc.refresh": "Aggiorna",
    "acc.headline.label": "Accuratezza validata",
    "acc.headline.empty": "Nessun caso ancora validato — vai nello Storico e marca alcune transazioni per popolare la dashboard.",
    "acc.headline.basis": "basato su",
    "acc.headline.basis2": "casi validati",
    "acc.summary.total": "Transazioni totali",
    "acc.summary.validated": "Validate",
    "acc.summary.pending": "In attesa",
    "acc.summary.coverage": "Copertura",
    "acc.byClass.title": "Accuratezza per classe di rischio",
    "acc.byClass.empty": "Valida almeno un caso per visualizzare la suddivisione per classe di rischio.",
    "acc.byClass.class": "Classe di rischio",
    "acc.byClass.cases": "Casi",
    "acc.byClass.correct": "Corretti",
    "acc.byClass.incorrect": "Errati",
    "acc.byClass.accuracy": "Accuratezza",
    "acc.byDay.title": "Ultimi N giorni",
    "acc.byDay.subtitle": "Accuratezza giornaliera (vengono mostrati solo i giorni con validazioni)",
    "acc.byDay.empty": "Nessun caso validato in questa finestra temporale.",
    "acc.byCaller.title": "Top chiamanti",
    "acc.byCaller.empty": "Nessun chiamante con casi validati al momento.",
    "acc.byCaller.email": "Chiamante",
    "acc.byCaller.cases": "Casi",
    "acc.byCaller.accuracy": "Accuratezza",
    "acc.window.7": "7 giorni",
    "acc.window.30": "30 giorni",
    "acc.window.90": "90 giorni",
    "acc.window.all": "Tutto",
    "acc.loading": "Calcolo delle metriche…",

    "nav.api": "API",
    "lang.label": "Lingua",
    "cfg.thr.labelFr": "Etichetta (FR)",
    "cfg.thr.labelEs": "Etichetta (ES)",
    "login.errors.failed": "Accesso non riuscito",
    "login.errors.cancelled": "L'accesso con Google è stato annullato",
    "tx.copyId": "Copia ID transazione",
    "docs.kicker": "Riferimento Sviluppatori · 04",
    "docs.title": "API per client HTTP",
    "docs.intro":
      "Il Sepsi Index Framework espone un'API REST. Qualsiasi client HTTP (curl, Postman, Python, un servizio backend…) può calcolare il rischio di sepsi dopo essersi autenticato con un'**identità Google** presente nella lista degli utenti autorizzati.",
    "docs.interactive.title": "Documentazione interattiva",
    "docs.interactive.body":
      "Lo schema OpenAPI 3.1 completo viene generato automaticamente. Usa Swagger UI per provare ogni endpoint dal vivo (incolla un Google ID token in **Authorize**), oppure importa il JSON in Postman, Insomnia o un generatore di codice OpenAPI.",
    "docs.interactive.swagger": "Apri Swagger UI",
    "docs.baseUrl": "URL di base",
    "docs.auth.title": "Autenticazione",
    "docs.auth.intro":
      "Passa un token Bearer nell'header `Authorization`. Il server accetta **due formati equivalenti** di token:",
    "docs.auth.google.title": "Google ID token (consigliato per i client HTTP)",
    "docs.auth.google.body":
      "— qualsiasi ID token emesso dall'OAuth di Google per il nostro client ID ({clientId}). Deve essere firmato RS256, avere un'email verificata e l'email deve essere nella lista autorizzati.",
    "docs.auth.app.title": "JWT dell'applicazione",
    "docs.auth.app.body":
      "— il token HS256 a breve durata restituito da `POST /api/auth/google` (usato dalla SPA dopo il popup di Google).",
    "docs.auth.errors":
      "In caso di `401` la risposta contiene `WWW-Authenticate: Bearer`. Un `403` indica che il token è valido ma l'email **non è nella lista autorizzati** — chiedi a un amministratore di aggiungerla dalla pagina **Configurazione → Utenti**.",
    "docs.endpoints.title": "Endpoint",
    "docs.col.method": "Metodo",
    "docs.col.path": "Percorso",
    "docs.col.auth": "Auth",
    "docs.col.desc": "Descrizione",
    "docs.bearerRequired": "Bearer richiesto",
    "docs.public": "pubblico",
    "docs.ep.calculate": "Calcola il rischio di sepsi per un paziente.",
    "docs.ep.health": "Verifica di disponibilità (numero di variabili/regole/versione).",
    "docs.ep.config": "Restituisce la configurazione attiva (sola lettura).",
    "docs.ep.examples": "Tre casi paziente predefiniti (rischio basso / medio / alto).",
    "docs.ep.configPut": "Sostituisce la configurazione attiva (admin).",
    "docs.ep.configReset": "Ripristina il modello di default (mantiene la lista autorizzati).",
    "docs.ep.configExtract": "Estrae una configurazione da un Excel di riferimento (upload multipart).",
    "docs.ep.emailsGet": "Elenca gli utenti autorizzati.",
    "docs.ep.emailsPut": "Sostituisce la lista autorizzati.",
    "docs.payload.title": "Payload della richiesta — POST /api/calculate",
    "docs.payload.body":
      "Il body contiene un unico oggetto `patient` con i 20 valori ematologici. I valori mancanti sono trattati come zero nel modello LDA e saltano le condizioni corrispondenti dell'albero decisionale.",
    "docs.curl.title": "Esempio · curl + gcloud",
    "docs.curl.body":
      "Il modo più semplice: dopo aver fatto login su gcloud (`gcloud auth login`) puoi generare ID token a breve durata associati al nostro client OAuth.",
    "docs.python.title": "Esempio · Python",
    "docs.python.body":
      "Richiede un **client OAuth di tipo App desktop** in Google Cloud Console (distinto dal client Web usato dalla SPA). Al primo avvio lo script apre una volta una scheda del browser; le esecuzioni successive riutilizzano automaticamente il refresh token salvato.",
    "docs.s2s.title": "Server-to-server (service account)",
    "docs.s2s.body":
      "Per le integrazioni backend, crea un **service account** Google Cloud, aggiungi la sua email (`name@project.iam.gserviceaccount.com`) alla lista autorizzati e usa `google.oauth2.service_account.IDTokenCredentials` con `target_audience` impostato sul nostro OAuth Client ID. L'ID token generato funziona allo stesso modo.",
    "docs.copy": "COPIA",
    "docs.copied": "COPIATO",
  },
  fr: FR,
  es: ES,
};

export const LOCALES = { en: "en-GB", it: "it-IT", fr: "fr-FR", es: "es-ES" };

// Secondary (non-English) risk label shown next to the English one.
export function secondaryRiskLabel(result, lang) {
  if (!result) return "";
  if (lang === "fr") return result.risk_class_fr || FR_RISK_LABELS[result.risk_class_en] || result.risk_class_en;
  if (lang === "es") return result.risk_class_es || ES_RISK_LABELS[result.risk_class_en] || result.risk_class_en;
  return result.risk_class_it;
}

export const SUPPORTED_LANGS = ["en", "it", "fr", "es"];
export const DEFAULT_LANG = "en";
